import { render, staticRenderFns } from "./IMValue.vue?vue&type=template&id=574f1940&"
import script from "./IMValue.vue?vue&type=script&lang=js&"
export * from "./IMValue.vue?vue&type=script&lang=js&"
import style0 from "./IMValue.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports